// @flow

import "./store.finder.scss";

type Suburb = {
    suburb: string,
    state: string,
    codeNumber: string
};

export function initStoreFinder() {
    const eleForm: HTMLFormElement = ((document.getElementById(
        "home-store-finder-form"
    ): any): HTMLFormElement);
    const eleBusIdenfitiers: HTMLSelectElement = ((document.getElementById(
        "home-store-finder-bus"
    ): any): HTMLSelectElement);
    const eleInput: HTMLInputElement = ((document.getElementById(
        "home-store-finder-input"
    ): any): HTMLInputElement);
    const eleOptionWrapper: HTMLElement = ((document.querySelector(
        ".store-finder-dropdown"
    ): any): HTMLElement);

    setupStoreFinder();

    function setupStoreFinder() {

        if(eleForm) {
            eleForm.addEventListener("submit", onQuerySubmit);
            let timeoutHandler = null;
            eleInput.addEventListener("input", () => {
                eleInput.dataset["selected"] = "";
                cancelTimeout(timeoutHandler);
                timeoutHandler = queueToRequestPostcode();
            });
        }
    }

    function getAddressParam(suburb: ?string, code: string) {
        const address = [];
        if (suburb) {
            let suburbObj: ?Suburb = null;
            try {
                suburbObj = JSON.parse(suburb);
            } catch (e) {
                return code;
            }
            suburbObj.suburb && address.push(suburbObj.suburb);
            suburbObj.codeNumber && address.push(suburbObj.codeNumber + "%2C");
            if (suburbObj.state) {
                address.push(suburbObj.state);
            }
            return address.join("+");
        }
        return code;
    }

    function onQuerySubmit(e) {
        e.preventDefault();
        const address = getAddressParam(
            eleInput.dataset.suburb,
            eleInput.value
        );
        const busId = eleBusIdenfitiers.value;
        const params = btoa(
            `address=${address}&businessUnitIdentifiers=${busId}`
        );
        window.location.href = `/storefinder#${params}`;
    }

    function cancelTimeout(handler) {
        handler && window.clearTimeout(handler);
    }

    function queueToRequestPostcode() {
        const query = eleInput.value;
        if (!query || query.length < 3) {
            return;
        }
        return window.setTimeout(async () => {
            const resp = await fetch(
                `/trsonline/stores/public/suburbs/search?query=${query}`
            );
            const data = await resp.json();
            clearSuburbOptions();
            appendSuburbOptions(data);
            updateOptionWrapperClass(data.length > 0);
        });
    }

    function updateOptionWrapperClass(hasItems) {
        if (hasItems) {
            eleOptionWrapper.classList.remove("empty");
        } else {
            eleOptionWrapper.classList.add("empty");
        }
    }

    function clearSuburbOptions() {
        eleOptionWrapper.innerHTML = "";
    }

    function appendSuburbOptions(data: Suburb[]) {
        data.map(suburb => {
            const li = document.createElement("li");
            li.classList.add("store-finder-dropdown__option-container");
            const span = document.createElement("span");
            span.classList.add("store-finder-dropdown__option");
            span.setAttribute("role", "option");
            span.innerHTML = `${suburb.suburb} ${suburb.codeNumber}, ${suburb.state}`;
            li.appendChild(span);
            li.addEventListener("click", selectOption(li, suburb));
            eleOptionWrapper.appendChild(li);
        });
    }

    function selectOption(li, suburb) {
        return () => {
            eleInput.value = suburb.codeNumber;
            eleInput.dataset["selected"] = JSON.stringify(suburb);
            clearSuburbOptions();
            updateOptionWrapperClass(false);
        };
    }
}
